import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DashboardUser from './pages/DashboardUser';
import DataAnggota from './pages/DataAnggota';
import DataPenerbit from './pages/DataPenerbit.jsx';
import Administrator from './pages/Administrator.jsx';
import DataBuku from './pages/DataBuku.jsx';
import KategoriBuku from './pages/KategoriBuku.jsx';
import DataPeminjaman from './pages/DataPeminjaman.jsx';
import DataPengembalian from './pages/DataPengembalian.jsx';
import Laporan from './pages/Laporan.jsx';
import ProfileUser from "./pages/ProfileUser";
import ProtectedRoute from './components/ProtectedRoute';
import HistoryAnggota from './pages/HistoryAnggota.jsx';

// Import komponen KoleksiBuku
import KoleksiBuku from './pages/KoleksiBuku.jsx';
import PeminjamanBuku from './pages/PeminjamanBuku.jsx';
import Leaderboard from './pages/Leaderboard.jsx';
import LaporanGamifikasi from './pages/LaporanGamifikasi.jsx';
import BookDetail from './pages/BookDetail';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        {/* Rute yang dilindungi untuk ADMIN */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredRole="admin">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dataanggota"
          element={
            <ProtectedRoute requiredRole="admin">
              <DataAnggota />
            </ProtectedRoute>
          }
        />
        <Route
          path="/datapenerbit"
          element={
            <ProtectedRoute requiredRole="admin">
              <DataPenerbit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/administrator"
          element={
            <ProtectedRoute requiredRole="admin">
              <Administrator />
            </ProtectedRoute>
          }
        />
        <Route
          path="/databuku"
          element={
            <ProtectedRoute requiredRole="admin">
              <DataBuku />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kategoribuku"
          element={
            <ProtectedRoute requiredRole="admin">
              <KategoriBuku />
            </ProtectedRoute>
          }
        />
        <Route
          path="/datapeminjaman"
          element={
            <ProtectedRoute requiredRole="admin">
              <DataPeminjaman />
            </ProtectedRoute>
          }
        />
        <Route
          path="/datakembali"
          element={
            <ProtectedRoute requiredRole="admin">
              <DataPengembalian />
            </ProtectedRoute>
          }
        />
        <Route
          path="/laporan"
          element={
            <ProtectedRoute requiredRole="admin">
              <Laporan />
            </ProtectedRoute>
          }
        />

        <Route
          path="/laporangamifikasi"
          element={
            <ProtectedRoute requiredRole="admin">
              <LaporanGamifikasi />
            </ProtectedRoute>
          }
        />

        <Route
          path="/historyanggota"
          element={
            <ProtectedRoute requiredRole="admin">
              <HistoryAnggota />
            </ProtectedRoute>
          }
        />

        {/* Rute yang dilindungi untuk ANGGOTA */}
        <Route
          path="/dashboard-user"
          element={
            <ProtectedRoute requiredRole="anggota">
              <DashboardUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute requiredRole="anggota">
              <ProfileUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/koleksibuku"
          element={
            <ProtectedRoute requiredRole="anggota">
              <KoleksiBuku />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PeminjamanBuku"
          element={
            <ProtectedRoute requiredRole="anggota">
              <PeminjamanBuku />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leaderboard"
          element={
            <ProtectedRoute requiredRole="anggota">
              <Leaderboard />
            </ProtectedRoute>
          }
        />
        
        {/* ✅ FIXED: Tambahkan route dengan prefix /user */}
        <Route
          path="/user/book/:id"
          element={
            <ProtectedRoute requiredRole="anggota">
              <BookDetail />
            </ProtectedRoute>
          }
        />
        
        {/* Route alternatif tanpa prefix (backward compatibility) */}
        <Route
          path="/book/:id"
          element={
            <ProtectedRoute requiredRole="anggota">
              <BookDetail />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;